<script lang="ts">
import BaseLabel from '@/components/globals/BaseLabel.vue'
import { Component } from 'vue-property-decorator'

@Component({})
export default class SuccessResultLabel extends BaseLabel {
  protected color = 'is-success'
}
</script>
